import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Divider } from '@mui/material';
import { Tag } from '@motusehf/web-ui-component-library/dist';
import GavelIcon from '@mui/icons-material/GavelOutlined';
import BalanceIcon from '@mui/icons-material/Balance';

const InfoModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: '40px 32px 24px 32px',
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '20px', sm: '24px', md: '32px' },
            fontWeight: 600,
          }}
          component="div"
        >
          Greiðslusamkomulög
        </Typography>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ p: '40px 32px' }}>
        <Typography variant="body1" paragraph sx={{ fontSize: '16px', mb: 3, fontWeight: 400 }}>
          Motus og Lögheimtan annast milligöngu um gerð greiðslusamkomulags með það að markmiði að létta greiðslubyrði.
          Mismunandi er eftir kröfuhöfum hvað þeir bjóða mikinn sveigjanleika og sömuleiðis skiptir máli hvar málið er
          statt í innheimtuferlinu. Eftirfarandi er leiðbeinandi fyrir þá möguleika sem bjóðast eftir innheimtustigi:
        </Typography>

        {/* Milliinnheimta Section */}
        <Box sx={{ mb: 3 }}>
          <Tag
            label="Milliinnheimta"
            color="#FAE0A7"
            fontWeight={700}
            sx={{
              fontSize: '16px',
              mb: 2,
              display: 'inline-block',
            }}
          />
          <Box component="ul" sx={{ ml: 2, mt: 1, pl: 0 }}>
            <Box component="li" sx={{ listStyle: 'disc', ml: 2 }}>
              <Typography variant="body2" sx={{ fontSize: '16px' }}>
                Hægt er að skipta greiðslum á 1 til 6 mánuðir eftir því hvað kröfuhafi leyfir.
              </Typography>
            </Box>
            <Box component="li" sx={{ listStyle: 'disc', ml: 2 }}>
              <Typography variant="body2" sx={{ fontSize: '16px' }}>
                Hægt er að gera eitt samkomulag fyrir 2 mál eða fleiri í milliinheimtu tilheyri þau sama kröfuhafa.
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Kröfuvakt Section */}
        <Box sx={{ mb: 3 }}>
          <Tag
            label="Kröfuvakt"
            color="#BFB3E5"
            fontWeight={700}
            sx={{
              fontSize: '16px',
              mb: 2,
              display: 'inline-block',
            }}
          />
          <Box component="ul" sx={{ ml: 2, mt: 1, pl: 0 }}>
            <Box component="li" sx={{ listStyle: 'disc', ml: 2 }}>
              <Typography variant="body2" sx={{ fontSize: '16px' }}>
                Hægt er að gera greiðslusamkomulag til allt að 12 mánaða, og þarf það ekki að vera fyrir
                heildarskuldinni.
              </Typography>
            </Box>
            <Box component="li" sx={{ listStyle: 'disc', ml: 2 }}>
              <Typography variant="body2" sx={{ fontSize: '16px' }}>
                Hægt er að endurnýja samkomulag eftir þann tíma
              </Typography>
            </Box>
            <Box component="li" sx={{ listStyle: 'disc', ml: 2 }}>
              <Typography variant="body2" sx={{ fontSize: '16px' }}>
                Hægt er að gera eitt samkomulag fyrir tvö kröfuvaktarmál eða fleiri þó þau tilheyri ekki öll sama
                kröfuhafa.
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Upphaf Löginnheimtu Section */}
        <Box sx={{ mb: 3 }}>
          <Tag
            label="Upphaf löginnheimtu"
            color="#E47B35"
            fontWeight={700}
            icon={<BalanceIcon sx={{ color: '#ffffff' }} />}
            iconPosition="right"
            textColor="#ffffff"
            sx={{
              fontSize: '16px',
              mb: 2,
              display: 'inline-block',
            }}
          />
          <Box component="ul" sx={{ ml: 2, mt: 1, pl: 0 }}>
            <Box component="li" sx={{ listStyle: 'disc', ml: 2 }}>
              <Typography variant="body2" sx={{ fontSize: '16px' }}>
                Hægt er að skipta greiðslum á 2 til 6 mánuðir eftir því hvað kröfuhafi leyfir.
              </Typography>
            </Box>
            <Box component="li" sx={{ listStyle: 'disc', ml: 2 }}>
              <Typography variant="body2" sx={{ fontSize: '16px' }}>
                Hægt er að gera eitt samkomulag fyrir 2 mál eða fleiri, tilheyri þau sama kröfuhafa
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Löginnheimta Section */}
        <Box sx={{ mb: 3 }}>
          <Tag
            label="Löginnheimta "
            color="#88233A"
            fontWeight={700}
            icon={<GavelIcon sx={{ color: '#ffffff' }} />}
            iconPosition="right"
            sx={{
              fontSize: '16px',
              mb: 2,
              display: 'inline-block',
            }}
          />
          <Box component="ul" sx={{ ml: 2, mt: 1, pl: 0 }}>
            <Box component="li" sx={{ listStyle: 'disc', ml: 2 }}>
              <Typography variant="body2" sx={{ fontSize: '16px' }}>
                Möguleikar á gerð samkomulags þarfnast alltaf skoðunar
              </Typography>
            </Box>
            <Box component="li" sx={{ listStyle: 'disc', ml: 2 }}>
              <Typography variant="body2" sx={{ fontSize: '16px' }}>
                Starfsfólk okkar fer yfir beiðnir um greiðslusamkomulög á þessu stigi. Svar ætti að berast eigi síðar en
                næsta virka dag.
              </Typography>
            </Box>
          </Box>
        </Box>

        <DialogActions sx={{ p: '16px 16px 0 16px', justifyContent: 'flex-end' }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              fontSize: '16px',
              textTransform: 'none',
              borderRadius: 1,
            }}
          >
            Loka glugganum
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default InfoModal;
